import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'CONSUL_OPER',
  title: 'Wie kann ich meine Projekte anzeigen?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Gehen Sie auf die Registerkarte "Projekte".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CONSUL_OPER/DE_CONSUL_OPER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'So gelangen Sie zur Gesamtansicht aller Ihrer aktuellen Projekte'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CONSUL_OPER/DE_CONSUL_OPER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Um weitere Details zu einem Projekt zu erhalten, klicken Sie es an'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CONSUL_OPER/DE_CONSUL_OPER_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Um das Projektdiagramm des Projekts aufzurufen, klicken Sie auf die Schaltfläche "Organigramm sehen".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CONSUL_OPER/DE_CONSUL_OPER_4.png`
  }]
};
